
 
  <div class="dialog-header">
    <h1>{{ID?'Редактировать паспорт КНТП':'Создать паспорт КНТП'}}</h1>
   
  </div>

 
  <form [formGroup]="passport_common_form" (ngSubmit)="onSubmit()" autocomplete="off" >
    <mat-tab-group animationDuration="0ms" [(selectedIndex)]="selected_tab">
      <mat-tab label="Общие положения" class="tab-content">
        
          
          <div class="form-row full-width">
            <mat-form-field appearance="fill" class="full-width">
              <mat-label>Название</mat-label>
              <input matInput formControlName="ShortTitle" placeholder="Введите название проекта">
              <mat-error *ngIf="submitted && f['ShortTitle']?.errors">
                <span *ngIf="f['ShortTitle']?.errors?.['required']">Поле не может быть пустым</span>
              </mat-error>
            </mat-form-field>
          </div>

          
          <div class="form-row full-width">
            <mat-form-field appearance="fill" class="full-width">
              <mat-label>Цель КНТП</mat-label>
              <input matInput formControlName="Goal" placeholder="Введите цель проекта">
              <mat-error *ngIf="submitted && f['Goal']?.errors">
                <span *ngIf="f['Goal']?.errors?.['required']">Поле не может быть пустым</span>
              </mat-error>
            </mat-form-field>
          </div>

          
          <div class="form-row two-columns">
            <mat-form-field appearance="fill">
              <mat-label>Тип КНТП</mat-label>
              <input matInput formControlName="Type" placeholder="Введите тип">
            </mat-form-field>

            <mat-form-field appearance="fill">
              <mat-label>Уровень секретности</mat-label>
              <mat-select formControlName="SecurityLevel" (selectionChange)="changeLevel($event)">
                <mat-option *ngFor="let level of security_data" [value]="level.Level">
                  {{ level.ShortTitle }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

   
          
           
             <mat-form-field appearance="fill">
              <mat-label>Дата инициации КНТП</mat-label>
              <input matInput formControlName="DateInitiation" [matDatepicker]="picker_initiation_date">
              <mat-datepicker-toggle matSuffix [for]="picker_initiation_date"></mat-datepicker-toggle>
              <mat-datepicker #picker_initiation_date></mat-datepicker>
              <mat-error *ngIf="submitted && f['DateInitiation']?.errors">
                <span *ngIf="f['DateInitiation']?.errors?.['required']">Поле обязательно</span>
              </mat-error>
            </mat-form-field>
            
         

          
          <div class="form-row full-width">
            <mat-form-field appearance="fill" class="full-width">
              <mat-label>Распорядительные документы</mat-label>
              <textarea matInput formControlName="Document" rows="2" placeholder="Перечислите документы"></textarea>
            </mat-form-field>
          </div>

          
          <div class="form-row full-width">
            <mat-form-field appearance="fill" class="full-width">
              <mat-label>Основные участники проекта</mat-label>
              <textarea matInput formControlName="Members" rows="2" placeholder="Перечислите участников"></textarea>
            </mat-form-field>
          </div>

           
            
            <mat-form-field appearance="fill">
              <mat-label>Реализация: начало</mat-label>
              <input matInput formControlName="StartDate" [matDatepicker]="picker_start_date">
              <mat-datepicker-toggle matSuffix [for]="picker_start_date"></mat-datepicker-toggle>
              <mat-datepicker #picker_start_date></mat-datepicker>
              <mat-error *ngIf="submitted && f['StartDate']?.errors">
                <span *ngIf="f['StartDate']?.errors?.['required']">Поле обязательно</span>
              </mat-error>
            </mat-form-field>

            <div class="date-separator" style="display:inline-block">—</div>

            <mat-form-field appearance="fill" style="display:inline-block">
              <mat-label>Реализация: окончание</mat-label>
              <input matInput formControlName="EndDate" [matDatepicker]="picker_end_date">
              <mat-datepicker-toggle matSuffix [for]="picker_end_date"></mat-datepicker-toggle>
              <mat-datepicker #picker_end_date></mat-datepicker>
              <mat-error *ngIf="submitted && f['EndDate']?.errors">
                <span *ngIf="f['EndDate']?.errors?.['required']">Поле обязательно</span>
              </mat-error>
            </mat-form-field>
         

          <div class="form-row two-columns" >
            
            
            <mat-form-field appearance="fill">
              <mat-label>Стоимость (млн. руб.)</mat-label>
              <input matInput type="number" formControlName="Costs" placeholder="0">
              <span matSuffix>₽</span>
            </mat-form-field>
          </div>
      </mat-tab>
            <mat-tab label="Целевые характеристики"  [disabled]="ID === undefined">

                <div class="mat-elevation-z8">
                    <!---------------->
                    <mat-toolbar>
                        <span>
                            <button mat-icon-button class="example-icon" aria-label="Example icon-button with menu icon"
                                (click)="GetTargetedTable()">
                                <mat-icon>refresh</mat-icon>
                            </button>
                        </span>

                        <span>
                            <button mat-icon-button aria-label="Example icon-button with a menu"
                                (click)="AddTargeted()">
                                <mat-icon>add</mat-icon>
                            </button>
                        </span>

                        <span class="flexExpand"></span>


                    </mat-toolbar>

                    <!--------Targeted table-->
                    <div class="mat-elevation-z8">
                        <mat-form-field>
                            <mat-label>Фильтр</mat-label>
                            <input matInput placeholder="Фильтр" (keyup)="Filterchange($event)">
                        </mat-form-field>

                        <table mat-table matSort [dataSource]="dataSourceTargeted" class="mat-elevation-z8">

                            <!-- ID Column -->
                            <ng-container matColumnDef="ID">
                                <th mat-header-cell mat-sort-header *matHeaderCellDef>ID</th>
                                <td mat-cell *matCellDef="let element"> {{element.ID}} </td>
                            </ng-container>

                            <!-- TypeTargeted Level -->
                            <ng-container matColumnDef="TypeTargeted">
                                <th mat-header-cell mat-sort-header *matHeaderCellDef>
                                    Тип
                                </th>
                                <td mat-cell *matCellDef="let element"> {{element.TypeTargeted}} </td>
                            </ng-container>

                            <!-- Name Column -->
                            <ng-container matColumnDef="Name">
                                <th mat-header-cell mat-sort-header *matHeaderCellDef>Название</th>
                                <td mat-cell *matCellDef="let element"> {{element.Name}} </td>
                            </ng-container>

                            <!-- Volume Column -->
                            <ng-container matColumnDef="Volume">
                                <th mat-header-cell mat-sort-header *matHeaderCellDef>Значение</th>
                                <td mat-cell *matCellDef="let element"> {{element.Volume}} </td>
                            </ng-container>

                            <!-- Remove Column -->
                            <ng-container matColumnDef="Remove">
                                <th mat-header-cell mat-sort-header *matHeaderCellDef>
                                    <fa-icon [icon]="faTrash"></fa-icon>
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    <button (click)="FunctionRemove(element)" mat-button>
                                        <fa-icon [icon]="faTrash" style="color: darkred;"></fa-icon>
                                    </button>
                                </td>

                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="displayedColumnsTargeted"></tr>
                            <tr (click)="getrow(row)" mat-row *matRowDef="let row; columns: displayedColumnsTargeted;">
                            </tr>
                        </table>

                        <mat-paginator [pageSize]="10" [pageSizeOptions]="[5,10,25,100]" showFirstLastButtons>

                        </mat-paginator>

                    </div>

                </div>
                <!-------------------->
            </mat-tab>
            <mat-tab label="Реестр технологий, входящих в КНТП" [disabled]="ID === undefined">
                <!---------------->
                <div class="mat-elevation-z8">
                    <!---------------->
                    <mat-toolbar>
                        <span>
                            <button mat-icon-button class="example-icon" aria-label="Example icon-button with menu icon"
                                (click)="GetRegistryTable()">
                                <mat-icon>refresh</mat-icon>
                            </button>
                        </span>

                        <span>
                            <button mat-icon-button aria-label="Example icon-button with a menu"
                                (click)="SelectRegistry()">
                                <mat-icon>add</mat-icon>
                            </button>
                        </span>

                        



                        <span class="flexExpand"></span>

                        <span>
                            <mat-slide-toggle class="example-margin" [(ngModel)]="show_archieved"
                                (change)="GetRegistryTable()" [ngModelOptions]="{standalone: true}">Показать
                                архивные</mat-slide-toggle>
                        </span>
                    </mat-toolbar>

                    <!--------RegistryList table-->
                    <div class="mat-elevation-z8">
                        <mat-form-field>
                            <mat-label>Фильтр</mat-label>
                            <input matInput placeholder="Поиск по реестру" (keyup)="FilterchangeRegistry($event)">
                        </mat-form-field>

                        <table mat-table matSort [dataSource]="dataSourceRegistry" class="mat-elevation-z8">

                            <!-- ID Column -->
                            <ng-container matColumnDef="ID">
                                <th mat-header-cell mat-sort-header *matHeaderCellDef>ID</th>
                                <td mat-cell *matCellDef="let element_table"> {{element_table.ID}} </td>
                            </ng-container>

                            <!-- ShortTitle -->
                            <ng-container matColumnDef="ShortTitle">
                                <th mat-header-cell mat-sort-header *matHeaderCellDef>
                                    Название
                                </th>
                                <td mat-cell *matCellDef="let element_table"> {{element_table.ShortTitle}} </td>
                            </ng-container>

                            <!-- SecurityLevel Column -->
                            <ng-container matColumnDef="SecurityLevel">
                                <th mat-header-cell mat-sort-header *matHeaderCellDef>
                                    <fa-icon [icon]="faShieldHalved"></fa-icon>
                                </th>
                                <td mat-cell *matCellDef="let element_table"> {{element_table.SecurityLevel}} </td>
                            </ng-container>

                            <!-- ArchiveSign Column -->
                            <ng-container matColumnDef="ArchiveSign">
                                <th mat-header-cell mat-sort-header *matHeaderCellDef>
                                    <fa-icon [icon]="faBoxArchive"></fa-icon>
                                </th>
                                <td mat-cell *matCellDef="let element_table">
                                    <mat-checkbox class="example-margin" [ngModelOptions]="{standalone: true}" [(ngModel)]="element_table.ArchiveSign"
                                        [disabled]="true"></mat-checkbox>
                                </td>
                            </ng-container>

                            <!-- Remove Column -->
                            <ng-container matColumnDef="Remove">
                                <th mat-header-cell mat-sort-header *matHeaderCellDef>
                                    <fa-icon [icon]="faTrash"></fa-icon>
                                </th>
                                <td mat-cell *matCellDef="let element_table">
                                    <button (click)="FunctionRemoveRegistry(element_table)" mat-button>
                                        <fa-icon [icon]="faTrash" style="color: darkred;"></fa-icon>
                                    </button>
                                </td>

                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="displayedColumnsRegistryList"></tr>
                            <tr (click)="getrowRegistry(row)" mat-row
                                *matRowDef="let row; columns: displayedColumnsRegistryList;"></tr>
                        </table>

                        <mat-paginator [pageSize]="10" [pageSizeOptions]="[5,10,25,100]" showFirstLastButtons>

                        </mat-paginator>

                    </div>

                </div>
                <!---------------->
            </mat-tab>
        </mat-tab-group>



        <div style="display: flex;">
            <button mat-raised-button color="primary" (click)="save()" style="margin-right: 5px;">Сохранить</button>
            <button mat-raised-button color="warn" (click)="exit()" style="margin-left: 5px;">Отмена</button>
        </div>
        

  </form>